import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Card, CardContent, Container, Drawer, FormControl, Slide, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { getUserAttempts, setUserAttempts } from '../../../../utils/content-utils';
import ErrorIcon from '@mui/icons-material/Error';
import { useNavigate } from 'react-router';
import Label from '../../../common/type/Label';
import { analyticsTrackEvent } from '../../../../utils/analytics/analytics-utils';
import { memberVerification, setMemberVerificationClean } from '../../../../redux/memberVerification/action';
import {formatDate} from '../../../common/functionUtils';
import { camelCaseString } from '../../../../utils/format-utils';
import moment from 'moment';

const useStyles = makeStyles((theme) => {
    return ({
        drawerPaper: {
            [theme.breakpoints.down('sm')]: {
                width: '100vw',
            },
            width: 411,
            backgroundColor: 'white'
        },
    });
});


const DependentCard = () => {
    // const dependentsCoverages = useSelector(state => state?.dependentCoverages);
    // const coveredMembers = useSelector(state => state?.coverages?.coveredMembers?.coveredMemberDetails);
    const enrollments = useSelector(state => state?.enrollments?.enrollmentsDetails);    
    const [openDrawer, setOpenDrawer] = useState(false);
    const classes = useStyles();
    const navigate = useNavigate();
    const [dependentInfo , setDependentInfo] = useState({firstName: '', lastName: '', dateOfBirth: '', medicaidId: ''});
    const [displayError, setDisplayError] = React.useState(false);

    const dispatch = useDispatch();

    const handleChange = (event)=> {
        setDependentInfo({...dependentInfo, [event.target.name] : event.target.value});
    };
    const handleDateChange = (event)=> {
        if(event.target.value)
            setDependentInfo({...dependentInfo, dateOfBirth: moment(event.target.value).format('YYYY-MM-DD') });
    };

    const memberAccounts = useSelector(
        state => state?.memberAccounts?.memberAccountsDetails
      );

    //   const mvDetailsFromStore = useSelector(
    //     state => state?.memberVerification?.memberVerificationDetails
    //   );

    useEffect(()=> {
        return ()=> {
            dispatch(setMemberVerificationClean());
        };
    },[]);
    const mvErrorFromStore = useSelector(
        state => state?.memberVerification?.error
      );
   
    const handleSubmit = (event)=> {
        event.preventDefault();
        let requestBody = {...dependentInfo , isDependent: true};
        setDisplayError(false);
        dispatch(memberVerification(requestBody, localStorage.getItem('tenantHandle')));
        analyticsTrackEvent('profile_add_dependent_clicked');
    };
    
    // React.useEffect(() => {
    //     if (mvDetailsFromStore?.status === 200) {
    //       setDependentsList([...dependentsList, dependentInfo]);
    //       handleClose();
          
    //     window.location.reload();
    //     }
    //   }, [mvDetailsFromStore]);

    React.useEffect(() => {
        setDisplayError(mvErrorFromStore);
    
        if(mvErrorFromStore && (mvErrorFromStore?.response?.status === 404 || mvErrorFromStore?.response?.status >= 500)){
          if(!getUserAttempts(dependentInfo && dependentInfo.medicaidId+'-count')){
          //set the count to 1 for that mediciaid id
          setUserAttempts(dependentInfo.medicaidId+'-count', 1);
        }else if(getUserAttempts(dependentInfo && dependentInfo.medicaidId+'-count')<2){
          //set and increase the count by 1 
          setUserAttempts(dependentInfo.medicaidId+'-count', Number(getUserAttempts(dependentInfo.medicaidId+'-count'))+1);
        }else if (getUserAttempts(dependentInfo && dependentInfo.medicaidId+'-count')<3 || getUserAttempts(dependentInfo.medicaidId+'-count')>=3){
          //increase count by 1 and redirect to uunidentified view
          setUserAttempts(dependentInfo.medicaidId+'-count', Number(getUserAttempts(dependentInfo.medicaidId+'-count'))+1);
          navigate('/unidentified');
        }
        } 
      }, [mvErrorFromStore]);
    return (
        <>
        <Box className='securityBox'>
            <Card className='securityBoxHeader dependentCard'>
            <h3 className='privacypolicy-section'><Label id="settingsDependentsLabel" /></h3>
                <Button variant='contained'  className='settingsBTN' onClick={() => setOpenDrawer(true)}><Label id="addDependent"/></Button>
            </Card>
            {displayError && mvErrorFromStore?.response?.status === 404 && (
              <Alert
                icon={<ErrorIcon sx={{ color: '#E00019' }} />}
                sx={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #E00019',
                  borderLeft: '4px solid #E00019'
                }}
                severity='error'
                onClose={() => setDisplayError(false)}
                id='userNotFoundError'
              >
               <Label id='404Error'/>
              </Alert>
            )}

            {displayError && mvErrorFromStore?.response?.status >= 500 && (
              <Alert
                icon={<ErrorIcon sx={{ color: '#E00019' }} />}
                sx={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #E00019',
                  borderLeft: '4px solid #E00019'
                }}
                severity='error'
                onClose={() => setDisplayError(false)}
                id='internalServerError'
              >
                <Label id='internalServerError'/>
              </Alert>
            )}
            {memberAccounts && memberAccounts.dependents && memberAccounts.dependents.map((member, index) => {
                return  <Card className='securityPassword' key={index}>
                    <CardContent className='passwordText'>
                        <Typography variant='body1' className='dependentFName'>
                            {camelCaseString(member?.firstName) + ' ' + camelCaseString(member?.lastName)}
                        </Typography>
                    </CardContent>
                    <CardContent className='passwordChangeText'>
                        <Typography vriant='body1'>
                            {/* Gender */}
                    </Typography>
                        <Typography vriant='body1'>
                            {/* {(coveredMembers[index + 1]?.gender) == 'M' ? 'Male' : 'Female'} */}
                        </Typography>
                    </CardContent>
                    <CardContent className='passwordChangeText'> 
                    {/* <Tooltip title="Date format MM/DD/YYYY" placement="top"> */}
                            <Typography>
                            <Label id="dateOfBirth" />
                            </Typography>
                            {/* </Tooltip> */}
                        <Typography vriant='body1'>
                            {enrollments?.birthDate ?formatDate(enrollments?.birthDate) : 'Not set'}
                        </Typography>
                    </CardContent>

                </Card>;
            })}
          
            {openDrawer && <Drawer anchor='right' classes={{ paper: classes?.drawerPaper }} variant='temporary' className='drawerForRequestCard' transitionDuration={500} open={openDrawer} onClose={() => setOpenDrawer(false)}>
                <Slide direction='left' in={
                    openDrawer
                }>
                    <Box className='drawerBox profileDrawerBox' >
                        <Box className='drawerBoxContent'>
                            <Container className='orderCardHeader'>
                                <Typography variant='h5'><Label id="addDependent" /></Typography>
                                <CancelOutlinedIcon onClick={() => setOpenDrawer(false)} />
                            </Container>
                            <Container component='form' className='formContainer' maxWidth='100%' onSubmit={handleSubmit}>
                                <FormControl className='newAddresContainer'>
                                    <div>
                                        <input className='inputfield' htmlFor='firstName' required name='firstName' value={dependentInfo.firstName} onChange={handleChange}></input>
                                        <label id='firstName' className='labelForInput'><Label id="firstName"/></label>
                                    </div>
                                    <div>
                                        <input className='inputfield' htmlFor='lastName' required name='lastName' value={dependentInfo.lastName} onChange={handleChange}></input>
                                        <label id='lastName' className='labelForInput'><Label id="lastName" /></label>
                                    </div>
                                    <div>
                                        <input className='inputfield' htmlFor='dateOfBirth' required name='dateOfBirth' value={dependentInfo.dateOfBirth} onChange={handleDateChange} type='date'/>
                                        <label id='dateOfBirth' className='labelForInput'><Label id="dateOfBirth"/></label>
                                    </div>
                                    <div>
                                        <input className='inputfield' htmlFor='medicaidId' required  name='medicaidId' value={dependentInfo.medicaidId} onChange={handleChange}></input>
                                        <label id='medicaidId' className='labelForInput'><Label id="medicaidId" /></label>
                                    </div>
                                    <div></div>
                                </FormControl>
                                <FormControl className='dependentActions'>
                                <Button variant='contained' id='clearRequestBtn' className='dependentClear' onClick={() =>setOpenDrawer(false)}><Label id="cancel"/></Button>
                                    <Button variant='contained' id='submitRequestBtn' className='submitButton dependentSubmit' type='submit' disabled={!dependentInfo.firstName.trimEnd() || !dependentInfo.lastName.trimEnd() || !dependentInfo.dateOfBirth || !dependentInfo.medicaidId.trimEnd()}>
                                        {/* <Label id="submitOrder"></Label> */}
                                        <Label id="addDependent" />
                                    </Button>
                                </FormControl>
                            </Container>
                        </Box>
                    </Box>
                </Slide>
            </Drawer>}
          
        </Box>
          <Card className='dependentSubText'>
              <Label id="toUpdateDependentsDemographicInfo" />
          : <Typography component='span' variant='body1' color='primary'><a rel="noreferrer" href="https://yourtexasbenefits.com/Learn/Home" target="_blank">yourtexasbenefits.com</a></Typography>
          </Card>
          </>
    );
};

export default DependentCard;
